module.exports = {
      // wx_app_id: 'wxd26f2ee0972036b4',  // 抖来金
      wx_app_id: 'wx83344776b5a4b354',  // 快来金
      // host_url: 'http://www.doulaijin.com',   // 本地服务器
      // host_url: 'https://fzy.cxzai.com',     // 远程服务器
      host_url: '',    // 远程服务器，本地代理调试
}
